// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"22863":"b448ba701f304ad0","27122":"dd0529764ccfba14","88390":"1ddc7ae2e620b3c9"}[chunkId] + ".css";
};